/**
 * Configuration interface for the virtual autocomplete component
 */
export interface VirtualAutocompleteConfig<T = any> {
  /** Function to display an item as a string */
  displayFn?: (item: T) => string;
  /** Function to filter items based on search text */
  filterFn?: (items: T[], searchText: string) => T[];
  /** Function to track items by a unique identifier for performance */
  trackByFn?: (index: number, item: T) => any;
  /** Debounce time for filtering in milliseconds */
  debounceTime?: number;
  /** Height of each item in pixels */
  itemSize?: number;
  /** Whether to show the clear button */
  showClearButton?: boolean;
}

/**
 * Default configuration values
 */
export const DEFAULT_VIRTUAL_AUTOCOMPLETE_CONFIG: Required<VirtualAutocompleteConfig> = {
  displayFn: (item: any) => item?.toString() || '',
  filterFn: (items: any[], searchText: string) => {
    if (!searchText) return items;
    const filterValue = searchText.toLowerCase();
    return items.filter(item => 
      item?.toString().toLowerCase().includes(filterValue)
    );
  },
  trackByFn: (index: number, item: any) => item?.id ?? index,
  debounceTime: 300,
  itemSize: 48,
  showClearButton: true
};


/**
 * Event emitted when selection changes
 */
export interface VirtualAutocompleteSelectionChange<T = any> {
  value: T | null;
  source: 'user' | 'programmatic';
}